(function ($) {
    var $fn = $(".comp_my_new_contract");

    if ($fn.length) {

    }
})(jQuery);